import React,{useState} from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import WelcomeNameContainer from "../LaunchComponent/WelcomeNameContainer";
import CommunicationTable from "./CommunicationTable";
import MyDesignsTable from "./MyDesignsTable";
import CampaignsTable from "./CampaignsTable";
import './tabs.css';

const DesignerTabs = () => {

    const [value, setValue] = React.useState("1");
     const handleChange = (event, newValue) => {
    setValue(newValue);
    };

  return (
    <div>
    <WelcomeNameContainer currentComp="designer" />  
    <div className="admintabs-container">
      <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              sx={{
                backgroundColor: "f0f4ff",
              }}
            >
              <Tab
                label="Communications"
                value="1"
                sx={{
                  textTransform: "capitalize",
                  "&.Mui-selected": {
                    color: "#022278",
                    fontWeight: 600,
                  },
                  color: "#000",
                }}
              />

              <Box
                sx={{
                  width: "0.5px",
                  height: "24px",
                  backgroundColor: "gray",
                  mx: 1,
                  marginTop: "12px",
                }}
              />
               <Tab
                label="Campaigns"
                value="2"
                sx={{
                  textTransform: "capitalize",
                  "&.Mui-selected": {
                    color: "#022278",
                    fontWeight: 600,
                  },
                  color: "#000",
                  
                }}
                className="powerBiTab"
              />
               <Box
                sx={{
                  width: "0.5px",
                  height: "24px",
                  backgroundColor: "gray",
                  mx: 1,
                  marginTop: "12px",
                }}
              />
              <Tab
                label="Designs"
                value="3"
                sx={{
                  textTransform: "capitalize",
                  "&.Mui-selected": {
                    color: "#022278",
                    fontWeight: 600,
                  },
                  color: "#000",
                  
                }}
                className="powerBiTab"
              />
            </TabList>
          </Box>

          <TabPanel value="1">
            <CommunicationTable/>
          </TabPanel>
          <TabPanel value="2">
            {/* <CampaignsTable/> */}
            <h1 style={{width:"100%", 
              height:"100%", 
              textAlign:"center",
              marginTop:"100px"
              }}>
                Coming soon. Stay tuned.
            </h1>
          </TabPanel>
          <TabPanel value="3">
            <MyDesignsTable/>
          </TabPanel>
      </TabContext>
    </div>
    </div>
  )
}

export default DesignerTabs;
